import {
    Component,
    inject,
    ElementRef,
    HostListener,
    Injector,
    OnDestroy,
    OnInit,
    QueryList,
    TemplateRef,
    ViewChild,
    ViewChildren,
    ChangeDetectorRef
} from '@angular/core';
import { Title } from '@angular/platform-browser';

import { BehaviorSubject, from, of, Subscription } from 'rxjs';
import { filter, catchError, map, mergeMap, switchMap, take, tap, distinctUntilChanged, scan } from 'rxjs/operators';
import moment from 'moment-timezone';
import { cloneDeep } from 'lodash';
import { MenuItem, MessageService } from 'primeng/api';

import { BlockModel } from '../../../../Common/PageBuilder/models/block.model';
import { BriefingsService } from '../../services/briefings.service';
import { BriefingModel } from '../../models/briefing.model';
import { TimeModel } from '../../../../Common/Forms/models/time.model';
import { timeFormatsEnum } from '../../../../Core/Users/enums/time-formats.enum';
import { PublishMetadataModel } from '../../../../Common/Dialogs/models/publish-metadata.model';
import { PublishStoryComponentTextModel } from '../../../../Common/Dialogs/models/publish-story-component-text.model';
import { BriefingRecurrencePatternModel } from '../../models/briefing-recurrence-pattern.model';
import { BriefingRecurrenceFrequencyEnum } from '../../enums/briefing-recurrence-frequency.enum';
import { deliverySchedulingTypesEnum } from '../../../../Common/Forms/enums/delivery-scheduling-types.enum';
import { MessageModel } from '../../../../Common/Misc/models/message.model';
import { messageSeverityEnum } from '../../../../Common/Misc/enums/message-severity.enum';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { BriefingStatusEnum } from '../../../../Common/MonitorShared/enum/briefing-status.enum';
import { TimeHelper } from '../../../../Common/Forms/helpers/time.helper';
import { AttributeModel } from '../../../../Common/Misc/models/attribute.model';
import { SentBriefingEnum } from '../../enums/sent-briefing-attributes.enum';
import { attributeTypesEnum } from '../../../../Common/Misc/enums/attribute-types.enum';
import { PreferencesModel } from '../../../../Core/Users/models/preferences.model';
import { BriefingSendNowHelper } from '../../helpers/briefing-send-now.helper';
import { DynamicMentionListDisplayElementModel } from '../../models/dynamic-mention-list-display-element.model';
import { TextDisplayElementModel } from '../../../../Common/PageBuilder/models/text-display-element.model';
import { BriefingBlockTypeEnum } from '../../enums/briefing-block-type.enum';
import { BriefingHistoryModel } from '../../models/briefing-history.model';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { userPermissionsEnum } from '../../../../Core/Users/enums/user-permissions.enum';
import { CopilotSwitchBannerVariantEnum } from '../../../../Common/Forms/components/CoPilotSwitchBanner/copilot-switch-banner-variant.enum';
import { BriefingsApiErrorEnum } from '../../../../api/briefings/enum/briefings-api-error.enum';
import { TabComponent } from '../../../../Common/Layout/components/Tab/tab.component';
import { Mention } from '../../../../Common/Mentions/models/mention';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ConfirmDialogComponent } from '../../../../Common/Dialogs/components/ConfirmDialog/confirm-dialog.component';
import { ConfirmDialogModel } from '../../../../Common/Dialogs/models/confirm-dialog.model';
import { TopicsService } from '../../../Core/services/topics.service';
import { MentionSearchListItemModel } from '../../../Shared/models/mention-search-list-item.model';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
import { BriefingPreviewDialogComponent } from '../BriefingPreviewDialog/briefing-preview-dialog.component';
import { validateEmails } from '../../../../Common/Misc/helpers/formatting/email.helper';
import { MentionSearchService } from '../../../Core/services/mention-search.service';
import { MonitoringSeriesTypeEnum } from '../../../../Monitor/Shared/enums/monitoring-series-type.enum';
import { PageBuilderComponent } from '../../../../Common/PageBuilder/components/PageBuilder/page-builder.component';
import { BriefingCanvasTemplateSetupComponent } from '../BriefingCanvasTemplateSetup/briefing-canvas-template-setup.component';
import { FormMessageComponent } from '../../../../Common/Forms/components/FormMessage/form-message.component';
import { AbstractPageBuilderService } from '../../../../Common/PageBuilder/services/abstract-page-builder.service';
import {
    BriefingSaveTemplateDialogComponent
} from '../BriefingSaveTemplateDialog/briefing-save-template-dialog.component';
import { CanvasSaveTemplateDialogComponent } from '../CanvasSaveTemplateDialog/canvas-save-template-dialog.component';
import { MediaSubscriptionService } from '../../../Core/services/media-subscription.service';
import { MailingListsService } from '../../../../Common/MailingLists/services/mailing-lists.service';
import { MailingListModel } from '../../../../Common/MailingLists/models/mailingList.model';
import { AutomaticCoverageDialogComponent } from '../AutomaticCoverageDialog/automatic-coverage-dialog.component';
import { PublishStoryComponent } from '../../../../Common/Dialogs/components/PublishStory/publish-story.component';
import { PublishStoryDialogModel } from '../../../../Common/Dialogs/models/publish-story-dialog.model';
import { deliveryOptionsEnum } from '../../../Shared/enums/delivery-options.enum';
import { SourceGroup } from '../../../../Common/Sources/models/source-group.model';
import { SourceGroupService } from '../../../../Common/Sources/services/source-group.service';
import { MediaSubscription } from '../../../../Monitor/Shared/models/media-subscription.model';
import { Theme } from '../../../../Social/Intelligence/models/theme.model';
import { AgentService } from '../../../../Social/Intelligence/services/agent.service';
import { ThemeService } from '../../../../Social/Intelligence/services/theme.service';
import { BriefingReservedUrlAttributes } from '../../enums/briefing-reserved-url-attributes.enum';
import { AgprComponentStyleEnum } from '../../../../Common/Basic/enums/social-analysis-types.enum';
import { FullProfileDialogAnimationsEnum } from '../../../../Core/Dialogs/enums/full-profile-dialog-animations.enum';
import { OverlayAnimationStateEnum } from '../../../../Core/Dialogs/enums/overlay-animation.enum';
import { FullProfileAnimationModel } from '../../../../Core/Dialogs/models/full-profile-animation.model';
import { MonitorConfigService } from '../../../../Common/MonitorShared/services/monitor-config.service';
import { ConfigService } from '../../../../Core/Config/services/config.service';
import { NewResourceDialogModel } from '../../../../Common/Dialogs/models/new-resource-dialog.model';
import { NewResourceDialogComponent } from '../../../../Common/Dialogs/components/NewResourceDialog/new-resource-dialog.component';
import { RSSFeedService } from '../../../Shared/services/rss-feed.service';
import { DisplayGroupModel } from '../../../../Common/Layout/models/display-group.model';
import { TagModel } from '../../../../Common/Tags/models/tag.model';
import { TagGroupModel } from '../../../../Common/Tags/models/tag-group.model';
import { TagsService } from '../../../../Common/Tags/services/tags.service';
import { TagGroupsService } from '../../../../Common/Tags/services/tag-groups.service';
import { ManuallyAddCoverageDialogComponent } from '../ManuallyAddCoverageDialog/manually-add-coverage-dialog.component';
import { BriefingStepIds, BriefingStepsEnum } from '../BriefingStepsNavigation/briefing-steps-navigation.component';
import { StepsBannerErrorConfigModel } from '@Common/Misc/models/banner-error-config.model';
import { AutoGenerateInsightResponse, BriefingsAutoGenService } from '../../services/briefings-auto-gen.service';
import { BriefingBannerErrorIdEnum } from '@Monitor/Briefings/enums/briefing-banner-error-type.enum';
import { BriefingComposeTabComponent } from '../BriefingComposeTab/briefing-compose-tab.component';
import { LayoutBlock } from '../../../../Common/PageBuilder/models/layout-block.model';
import { AnalysisDisplayElementModel } from '@Monitor/Briefings/models/briefing-analysis-display-element.model';
import { FolderService } from '@Monitor/Core/services/folder.service';
import { Folder } from '@Monitor/Shared/models/folder.model';
import { AiAnalysisTypes } from '@Common/Mentions/enums/ai-analysis-types.enum';
import { curatedMentionListBlockType } from '../../models/briefings-block-types.model';
import { LinkDisplayElementModel } from '../../../../Common/PageBuilder/models/link-display-element.model';
import { BriefingSeriesService } from '../../services/briefing-series.service';
import { BriefingChartDisplayElementModel } from '../../../../Common/PageBuilder/models/briefing-chart-display-element.model';
import { BriefingDeliveryMethodEnum } from '../../enums/briefing-delivery-method.enum';
import { BriefingImageDisplayElementModel } from '@Common/PageBuilder/models/briefing-image-display-element.model';
import { BriefingGeneratingPdfDialogComponent } from '../BriefingGeneratingPdfDialog/briefing-generating-pdf-dialog.component';
import { CuratorBlock } from '../../../../Common/PageBuilder/models/curator-block.model';
import { CuratorDisplayElement } from '../../../../Common/PageBuilder/models/curator-display-element.model';
import { ImageSourceEnum } from '../../../../Common/PageBuilder/enums/image-source.enum';
import { ChatMessageTypeModel } from '@api/ai/enums/AI-chat-completion.enum';
import { MentionInsightTypes } from '@Common/Mentions/enums/mention-insight-types.enum';
import { MAX_BASE_64_IMAGE_SIZE } from '../../../../Core/constants';
import { BriefingImageFrameEnum } from '../../../Shared/enums/briefing-image-frame.enum';
import { OnlineBriefingBannerStyleEnum } from '../../enums/online-briefing-banner-style.enum';
import { BriefingImagePropertiesModel } from '../../../../Common/PageBuilder/models/briefing-image-properties.model';
import { BriefingsTemplateFactorService } from '../../services/briefings-template-factory.service';
import { OnlineBriefingTemplateConfigModel } from '../../models/online-briefing-option.model';
import { OnlineBriefingTemplateEnum } from '../../enums/online-briefing-template.enum';
import { BriefingTitleDisplayElementModel } from '../../models/briefing-title-display-element.model';
import { BriefingCoverageAnalysisService } from '../../services/briefing-coverage-analysis.service';
import { DateDisplayElementModel } from '@Common/PageBuilder/models/date-display-element.model';
import { BriefingDateRangeTypeEnum } from '@Monitor/Briefings/enums/briefing-date-range-type.enum';
import { DateQueryModel } from '@Common/Forms/models/date-query.model';
import { RelativeTimezoneDateTypeEnum } from '@api/mentions/enum/relative-timezone-date-type.enum';
import { ProgressModel } from '@Common/Dialogs/models/progress.model';
import { ProgressDialogComponent } from '../../../../Common/Dialogs/components/ProgressDialog/progress-dialog.component';
import { MonitoringPrecisionClipService, PrecisionResourceType, PrecisionClipProcess } from '@Monitor/Shared/services/monitoring-precision-clip.service';
import { PrecisionConfirmDialogComponent } from '../PrecisionConfirmDialog/precision-confirm-dialog.component';
import { AiAgentsListService } from '../../../../AutomationAgents/services/ai-agents-list.service';
import { CurationAgentModel } from '../../../../AutomationAgents/models/curation-agent.model';

export enum BriefingsSplitButtonType {
    saveBriefing = 'saveBriefing',
    refreshData = 'refreshData',
}

@Component({
    selector: 'agpr-briefing',
    templateUrl: './briefing.component.html',
    styleUrls: ['./briefing.component.scss'],
    providers: [
        {
            provide: AbstractPageBuilderService,
            useExisting: BriefingsService
        },
        MentionSearchService
    ],
    standalone: false
})
export class BriefingComponent implements OnInit, OnDestroy {

    @ViewChild(BriefingCanvasTemplateSetupComponent) canvasTemplateSetup: BriefingCanvasTemplateSetupComponent;
    @ViewChild('blockFormTab') blockFormTab: TabComponent;
    @ViewChild('briefingComposeTab') briefingComposeTab: BriefingComposeTabComponent;
    @ViewChild(PageBuilderComponent) pageBuilder: PageBuilderComponent;
    @ViewChildren(FormMessageComponent, { read: ElementRef }) formErrors: QueryList<ElementRef>;
    @ViewChild('rssFeedDisclaimer') rssFeedDisclaimer: TemplateRef<any>;
    @ViewChild('rssFeedSentDetails') rssFeedSentDetails: TemplateRef<any>;

    selectedBlock: BlockModel;
    selectedTabIndex: number = 0;

    currentStep: BriefingStepsEnum = BriefingStepsEnum.compose;
    compositionErrors: StepsBannerErrorConfigModel[] = [];
    publishingErrors: StepsBannerErrorConfigModel[] = [];
    bannerErrorList: StepsBannerErrorConfigModel[] = [];
    hasChartBlockImageSizeError = false;

    // Recipient chips component variables.
    recipients: string[] = [];
    splitOnPattern: RegExp = new RegExp('[,;]');

    // Scheduling component variables.
    // TODO: make this not use any once delivery scheduler accepts a single object input
    deliverySchedulerInputFields: any = {
        minDate: new Date(),
        deliveryDate: new Date(),
        deliveryTime: {
            format: timeFormatsEnum.twelveHour,
            hour: null,
            minute: null,
            timeZone: null
        } as TimeModel,
        recurrenceModel: new BriefingRecurrencePatternModel(),
        schedulingType: deliverySchedulingTypesEnum.immediate
    };
    deliverySchedulerMessages: MessageModel[] = [];

    briefing: BriefingModel;
    loadingBriefing: boolean = true;
    briefingHistory: BriefingHistoryModel;
    sentDetails: AttributeModel[] = [];
    briefingDetails: AttributeModel[] = [];
    preferences: PreferencesModel;
    mentionsSelected: boolean = false;
    deleteSelectedMentions: boolean = false;
    reservedUrl: string;
    reservedUrlDetails: AttributeModel[] = [];
    isAutoGenBannerExpanded: boolean = false;
    canSaveBriefing: boolean = true;

    maxNumberOfMentionsInBriefing: number = 0;
    allocatedMentionsCount: number = 0;
    briefingCuratedMentions: Mention[] = [];

    draftPublished: boolean = false;
    publishDraftInProgress: boolean = false;
    schedulingError: StepsBannerErrorConfigModel = new StepsBannerErrorConfigModel();

    confirmationDialogLocalization: PublishStoryComponentTextModel = {
        confirmationInformation: 'Briefings.sendBriefing',
        authorTitle: '',
        iAgree: 'Briefings.confirmationDialog.iAgree',
        agreePublish: 'Briefings.confirmationDialog.agreeAndSubmit',
        cancel: 'Briefing.cancelButtonLabel',
        confirmationMessage: '',
        confirmation: '',
        publish: '',
        headerTitle: 'Briefings.briefing',
        headerSubTitle: 'Briefings.confirmationDialog.subtitleLine1',
        headerContent: 'Briefings.confirmationDialog.subtitleLine2',
        publishLoader: 'Briefings.confirmationDialog.publishingLoading'
    };
    confirmationDialogMetadata: PublishMetadataModel[] = [];

    isClean: boolean = false;
    isScheduled: boolean = false;
    isSending: boolean = false;
    editable: boolean = true;
    loadingTemplates: boolean;
    loadingCuratedMentions: boolean;

    showErrorsLevel: number = 0;

    replyToEmailValid: boolean = true;
    showReplyToErrorMsg: boolean = false;
    showSubjectLengthErrorMsg: boolean = false;
    showFromNameLengthErrorMsg: boolean = false;
    showReplyToEmailLengthErrorMsg: boolean = false;
    showNoBlocksSelectedErrorMsg: boolean = false;
    showMailingListError: boolean = false;
    requireAutomaticInsightGen: boolean = false;
    hasOpenAI: boolean = false;
    hasCoverageInsights: boolean = false;

    numAutoGenMentions: number = 0;

    // autoGen variables
    autoGensStatus: AutoGenerateInsightResponse;
    allAutoGensStatus: {
        [key: number]: AutoGenerateInsightResponse;
    } = {};

    precisionClipProcess: PrecisionClipProcess;

    validBriefingName: boolean = true;
    duplicateBriefingName: boolean = false;
    showErrors: boolean = false;
    submitInProgress: boolean = false;
    saveInProgress: boolean = false;
    hasMentionInsightsEnabled: boolean = false;
    includeMentionsInPDF: boolean = false;
    hasDynamicElements: boolean = false;

    // Burrelles no longer counts as a reseller
    isResellerAccount: boolean = false;

    cachedSchedulingType: deliverySchedulingTypesEnum;

    draggingMentions: boolean = false;
    pageHeading: string;

    iframeElement: HTMLIFrameElement;
    generatingPDF: boolean = false;


    private cachedCanvasPreview: OnlineBriefingTemplateConfigModel | null = null;
    private topics: MentionSearchListItemModel[];
    private folders: Folder[];
    private tags: TagModel[];
    private tagGroups: TagGroupModel[];
    private mentionBlocks: BlockModel[];

    private mediaSubscriptions: MediaSubscription[];
    private sourceGroups: SourceGroup[];
    private socialTopics: MediaSubscription[];
    private socialThemes: Theme[];
    private aiAgents: CurationAgentModel[];
    private aiAgentsListService: AiAgentsListService = inject(AiAgentsListService);

    private progress: ProgressModel = null;
    private chartBlocks: BlockModel[] = [];
    private chartBlocksLoadedInProgressBar: number[] = [];

    private mailingLists: MailingListModel[];
    private showSendConfirmationOnLoad: boolean = false;
    private maxInputTextLength: number = 256;

    private subscriptions: Subscription[] = [];

    readonly noErrors: number = 0;
    readonly draftErrors: number = 1;
    readonly sendPreviewErrors: number = 2;
    readonly sendErrors: number = 3;

    readonly defaultSelectedTabIndex: number = 0;
    readonly setupTabIndex: number = 0;
    readonly blockFormTabIndex: number = 1;
    readonly sortToolTabIndex: number = 2;
    readonly generalStylesTabIndex: number = 3;
    readonly pdfTabIndex: number = 4;
    readonly detailsTabIndex: number = 5;
    readonly briefingStepIds = BriefingStepIds;
    readonly briefingSteps = BriefingStepsEnum;

    readonly id: string = 'briefings';
    readonly messageSeverityEnum = messageSeverityEnum;
    readonly deliveryOptionsEnum = deliveryOptionsEnum;
    readonly agprComponentStyleEnum = AgprComponentStyleEnum;
    readonly buttonTypes = ButtonTypesEnum;
    readonly briefingStatus = BriefingStatusEnum;
    readonly deliveryTypes = deliverySchedulingTypesEnum;
    readonly mentionBlockType = curatedMentionListBlockType;
    readonly deliveryMethods = BriefingDeliveryMethodEnum;
    readonly copilotSwitchBannerVariantEnum = CopilotSwitchBannerVariantEnum;
    readonly MAX_NUM_CURATED_MENTIONS_ANALYZED: number = 400;
    readonly MAX_NUM_DYNAMIC_MENTIONS_ANALYZED: number = 10000;
    readonly addMentionsActions: MenuItem[] = [
        {
            label: this.localizationService.transform('Briefings.addCoverage.manual'),
            command: () => this.openManuallyAddMentionDialog()
        },
        {
            label: this.localizationService.transform('Briefings.addCoverage.automatic'),
            command: () => this.automaticallyAddMentions()
        }
    ];
    readonly actions: MenuItem[] = [
        {
            label: 'Briefing.saveAsDraftButtonLabel',
            value: BriefingsSplitButtonType.saveBriefing,
            command: () => this.saveAsDraft()
        },
        {
            label: 'Briefing.refreshData',
            value: BriefingsSplitButtonType.refreshData,
            command: () => this.openRefreshDataDialog()
        }
    ];

    constructor(
        public briefingsService: BriefingsService,
        public localizationService: LocalizationService,
        public timeHelper: TimeHelper,
        private currentUserStateService: CurrentUserStateService,
        private briefingSendNowHelper: BriefingSendNowHelper,
        private topicsService: TopicsService,
        private coreDialogService: CoreDialogService,
        private mediaSubscriptionService: MediaSubscriptionService,
        private mailingListsService: MailingListsService,
        private folderService: FolderService,
        private sourceGroupsService: SourceGroupService,
        public titleService: Title,
        private messageService: MessageService,
        private themeService: ThemeService,
        private agentService: AgentService,
        public monitorConfigService: MonitorConfigService,
        private configService: ConfigService,
        private rssFeedService: RSSFeedService,
        private tagsService: TagsService,
        private tagGroupsService: TagGroupsService,
        private briefingsAutoGenService: BriefingsAutoGenService,
        private precisionClipService: MonitoringPrecisionClipService,
        private briefingSeriesService: BriefingSeriesService,
        public injector: Injector,
        private cd: ChangeDetectorRef,
        private briefingsTemplateFactorService: BriefingsTemplateFactorService,
        private briefingCoverageAnalysisService: BriefingCoverageAnalysisService,
    ) {
        this.briefingsService.briefingComponentInjector = injector;
    }

    ngOnInit(): void {
        this.autoGensStatus = null;
        this.maxNumberOfMentionsInBriefing = this.briefingsService.maxNumberOfMentionsInBriefing;
        this.isResellerAccount = this.configService.hasBrandGUID() && !this.configService.brandGUIDIsBurrelles();
        this.briefingsService.setBlockMaxWidth(640);
        this.subscriptions.push(
            this.currentUserStateService.hasAnyPermissions([userPermissionsEnum.openAI]).subscribe(hasPermission => {
                this.hasOpenAI = hasPermission;
            }),
            this.monitorConfigService.getHasCoverageInsightsEnabled().subscribe(hasEnabled => {
                this.hasCoverageInsights = hasEnabled;
            }),
            this.briefingsService.hasDefaultTemplates().subscribe(hasDefaultTemplates => this.loadingTemplates = !hasDefaultTemplates),
            this.briefingsService.getSelectedBlock().subscribe(
                (block: BlockModel) => {
                    this.selectedBlock = block;

                    if (this.selectedBlock) {
                        if (this.selectedTabIndex !== this.sortToolTabIndex && !this.briefing?.isPreviewMode) {
                            // HACK: changing the tab index here doesn't actually select it unless the block form tab is already enabled
                            // This is because the disabled property in the template is handled after the tab index
                            // So we change the disabled state manually to handle that
                            if (this.blockFormTab) {
                                this.blockFormTab.disabled = false;
                            }
                            this.selectedTabIndex = this.blockFormTabIndex;

                            if (
                                (this.selectedBlock.type.key !== BriefingBlockTypeEnum.TEXT) &&
                                (this.selectedBlock.type.key !== BriefingBlockTypeEnum.ANALYSIS)
                            ) {
                                const formSelector = 'agpr-block-form';

                                requestAnimationFrame(() => {
                                    const blockForm = document.querySelector(formSelector);
                                    const firstInput: HTMLElement = blockForm?.querySelector('input, button, [role=button], textarea');
                                    firstInput?.focus();
                                });
                            }
                        }
                    } else if (this.selectedTabIndex === this.blockFormTabIndex && !this.briefing?.isPreviewMode) {
                        this.selectedTabIndex = this.defaultSelectedTabIndex;
                    }
                }
            ),
            this.briefingsService.getFocusedResource().pipe(
                tap(briefingModel => {
                    if (briefingModel?.id !== this.briefing?.id) {
                        this.sentDetails = [];
                    }
                    if (!briefingModel) {
                        // TODO: loading here
                        return;
                    }

                    this.setBriefing(briefingModel);

                    this.validate(this.draftErrors);

                    this.briefingChanged();
                    this.isSending = false;
                    if (briefingModel) {
                        this.titleService.setTitle(
                            this.localizationService.transform(
                                briefingModel.deliveryMethod === BriefingDeliveryMethodEnum.EMAIL ?
                                    'Monitoring.briefings.browserTitle.name' : 'Monitoring.canvas.browserTitle.name',
                                { name: briefingModel.name }
                            )
                        );
                    }

                    this.checkIfHasAutoGenInsights();
                    this.checkAutoGensStatus();
                    this.mentionBlocks = this.briefingsService.getAllMentionBlocks();
                    this.iframeElement = document.getElementById('briefing_pdf_iframe') as HTMLIFrameElement;
                }),
                map(briefingModel => briefingModel?.id),
                distinctUntilChanged(),
                switchMap(() => this.precisionClipService.watch(this.briefing?.id, PrecisionResourceType.BRIEFING)),
                filter(x => !!x),
                scan((acc, current) => ({ previous: acc.current, current }), { previous: null, current: null }),
                filter(({ current }) => !!current),
                tap(({ previous, current }) => {
                    this.precisionClipProcess = current;
                    if (current.status === 'completed' && previous.status !== 'completed') {
                        const io = {
                            inputs: {
                                id: 'precision_clip_complete',
                                successCount: this.precisionClipProcess.clipsCompleted,
                                failedCount: this.precisionClipProcess.clipsFailed || 0,
                                width: 600
                            },
                            outputs: {}
                        };
                        this.coreDialogService.open(PrecisionConfirmDialogComponent, io);
                    }
                })
            ).subscribe(),
            this.briefingsService.showSendConfirmationOnLoad$.subscribe(x => this.showSendConfirmationOnLoad = x),
            this.briefingsService.getBriefingHistory().pipe(
                tap(briefingHistory => {
                    if (briefingHistory) {
                        this.briefingHistory = briefingHistory;
                        this.draftPublished = !!this.briefingHistory.submittedDate;
                        if (this.draftPublished && this.preferences?.timeZone) {
                            this.setReservedUrlDetails();
                        }
                    } else {
                        this.draftPublished = false;
                        this.reservedUrlDetails = [];
                    }
                }),
                mergeMap(briefingHistory => this.rssFeedService.getByIds(briefingHistory?.feedIds))
            ).subscribe(rssFeeds => this.briefing?.setFeedNameAndUrl(rssFeeds)),
            this.briefingsService.getImportDialogProvider().subscribe(
                (block) => {
                    this.openManuallyAddMentionDialog(block);
                }
            ),
            this.briefingsService.getGeneralStyles().subscribe(
                generalStyles => {
                    if (generalStyles && this.briefing) {
                        this.briefing.generalStyles.setStyles(generalStyles);
                        this.briefingChanged();
                    }
                }
            ),
            this.briefingsService.getCurrentBriefingMentions().subscribe(
                mentions => {
                    this.briefingCuratedMentions = mentions || [];
                }
            ),
            this.briefingsService.getCurrentBriefingAllocatedMentionsCountProvider().subscribe(
                allocatedMentionsCount => {
                    this.allocatedMentionsCount = allocatedMentionsCount;
                }
            ),
            this.briefingsService.loading$.subscribe(x => this.loadingBriefing = x),
            this.currentUserStateService.getPreferences().pipe(filter(x => !!x)).subscribe(
                preferences => {
                    if (preferences) {
                        this.preferences = preferences;

                        this.setBriefingDetails();

                        if (this.draftPublished) {
                            this.setReservedUrlDetails();
                        }
                    }
                }
            ),
            this.topicsService.getTopics().subscribe(
                topics => this.topics = topics
            ),
            this.mediaSubscriptionService.all$.subscribe(
                mediaSubscriptions => {
                    this.mediaSubscriptions = mediaSubscriptions;
                }
            ),
            this.mailingListsService.getMailingLists().subscribe(
                mailingLists => this.mailingLists = mailingLists
            ),
            this.folderService.all$.subscribe(
                folders => this.folders = folders
            ),
            this.tagsService.all$.subscribe(tags => this.tags = tags),
            this.tagGroupsService.getTagGroupsList().subscribe(tagGroups => this.tagGroups = tagGroups),
            this.sourceGroupsService.all$.subscribe(
                sourceGroups => this.sourceGroups = sourceGroups
            ),
            this.agentService.all$.subscribe(
                agents => this.socialTopics = agents
            ),
            this.themeService.all$.subscribe(
                socialThemesList => this.socialThemes = socialThemesList
            ),
            this.aiAgentsListService.all$.subscribe(
                aiAgents => this.aiAgents = aiAgents
            ),
            this.briefingsService.loadingCuratedMentions$.subscribe(x => this.loadingCuratedMentions = x),
            this.monitorConfigService.getHasMentionInsightsEnabled().subscribe(x => this.hasMentionInsightsEnabled = x),
            this.briefingsAutoGenService.getAutoGenStatus().subscribe(autoGensStatus => {
                this.allAutoGensStatus = autoGensStatus;
                this.checkAutoGensStatus();
            }),
            this.briefingsService.dirtyCheck$.subscribe((check) => {
                if (check) {
                    this.briefingChanged();
                }
            }),
            this.briefingsService.refreshChartBlockData().pipe(
                filter(x => !!x),
                switchMap(x => from(this.briefingSeriesService.resetSeries(x)).pipe(map(() => x))),
                switchMap(x => this.briefingSeriesService.prepareSeries(x).pipe(map(() => x))),
                tap((blocks) => {
                    this.briefingChanged();
                    requestAnimationFrame(() => {
                        blocks?.forEach(block => {
                            if (block.type.key === BriefingBlockTypeEnum.CHART) {
                                this.briefingsService.notifyBlockDisplayElementChanged(block);
                            }
                        });
                    });
                })
            ).subscribe(),
            this.briefingsService.hasDynamicElements$.subscribe(x => {
                this.hasDynamicElements = x;
                this.shouldActionsBeDisabled();
            }),
            this.briefingsService.getIncrementRefreshAllProgressBar().subscribe(x => {
                if (this.progress) {
                    // for some reason, when we refresh the data on a chart, the dataProvider triggers multiple times
                    // so we do this check to make sure only one will be added to the progress bar
                    if (!this.chartBlocksLoadedInProgressBar.includes(x.uniqueId)) {
                        this.chartBlocksLoadedInProgressBar.push(x.uniqueId);
                        this.progress.currentIndex++;
                        if (this.progress.totalItems <= this.progress.currentIndex) {
                            // HACK: set half second timeout to show the progress bar load before closing
                            setTimeout(() => {
                                this.coreDialogService.close('Progress');
                                this.progress = null;
                            }, 500);
                        }
                    }
                }
            })
        );
    }

    @HostListener('window:beforeunload', ['$event'])
    pageUnload($event) {
        if (!this.briefingsService.canLeaveCurrentBriefing()) {
            $event.returnValue = this.localizationService.transform('DeactivateGuard.messageText');
        }
    }

    scrollToAddedBlock(block: ElementRef): void {
        this.briefingComposeTab.scrollPanel.scrollIntoView(block);
    }

    removeAllMentions(): void {
        this.coreDialogService.open(
            ConfirmDialogComponent,
            <ConfirmDialogModel>{
                inputs: {
                    heading: 'Briefing.removeAllMentions.dialog.heading',
                    message: 'Briefing.removeAllMentions.dialog.message',
                    okLabel: 'Briefing.removeAllMentions.dialog.confirm',
                    id: 'briefing',
                    width: 300
                },
                outputs: {
                    dialogClose: (confirm: boolean) => {
                        if (!confirm) {
                            return;
                        }

                        this.briefingsService.clearMentions();
                        this.briefingsService.formFieldUpdated();
                        this.briefingChanged();
                    }
                }
            }
        );
    }

    saveAsDraft(sendAfterSave: boolean = false): void {
        if (!this.canSave()) {
            return;
        }
        this.briefingsService.setCurrentBriefing(this.briefing);
        if (!this.briefing.id) {
            const io: NewResourceDialogModel = {
                inputs: {
                    id: 'nameBriefing',
                    heading: 'Briefing.nameBriefingDialog.heading',
                    okLabel: 'Briefing.confirm',
                    placeholder: 'Briefing.renameBriefingDialog.placeholder',
                    description: 'Briefing.renameBriefingDialog.description',
                    initialValue: this.briefing.name,
                    formValidator: (name: string) => {
                        if (this.briefingsService.isBriefingNameDuplicate(name)) {
                            return [
                                'Briefing.copyBriefingDuplicateNameErrorMessage'
                            ];
                        }

                        return [];
                    },
                    submit: (name: string, group?: DisplayGroupModel) => {
                        this.briefing.name = name;
                        this.briefing.groupId = group?.id;

                        return this.briefingsService.saveCurrentBriefing().pipe(
                            tap(() => {
                                this.isClean = true;
                                this.saveInProgress = false;
                                if (sendAfterSave) {
                                    this.setShowSendConfirmation(true);
                                }
                            }),
                            catchError((err) => {
                                this.saveInProgress = false;
                                throw err;
                            })
                        );
                    }
                },
                outputs: {
                    dialogClose: () => {
                        this.saveInProgress = false;
                    }
                }
            };
            this.coreDialogService.open(NewResourceDialogComponent, io);
        } else {
            // need to subscribe to observable for it run
            this.briefingsService.saveCurrentBriefing().subscribe({
                next: () => {
                    this.isClean = true;
                    this.saveInProgress = false;
                    if (sendAfterSave) {
                        this.setShowSendConfirmation(true);
                    }
                },
                error: () => this.saveInProgress = false,
            });
        }
    }

    private checkRecurringDateRange() {
        if (!this.briefing?.sendAt?.recurring) {
            this.briefing.blocks.forEach(block => {
                if (block.type.key === BriefingBlockTypeEnum.DATE) {
                    this.setDefeaultDateRange(block);
                }
                if (block.isLayoutBlockType()) {
                    (block as LayoutBlock).blocks?.forEach(items => {
                        items?.forEach(item => {
                            if (item.type.key === BriefingBlockTypeEnum.DATE) {
                                this.setDefeaultDateRange(item);
                            }
                        });
                    });
                }
            });
        }
    }

    setDefeaultDateRange(block: BlockModel) {
        if ((block.displayElement as DateDisplayElementModel).dateRangeType === BriefingDateRangeTypeEnum.RECURRENCE) {
            (block.displayElement as DateDisplayElementModel).dateQuery = DateQueryModel.getRelativeTimezoneQuery(RelativeTimezoneDateTypeEnum.LAST_24_HOURS);
            (block.displayElement as DateDisplayElementModel).dateQuery.timezone = this.preferences?.timeZone;
            (block.displayElement as DateDisplayElementModel).dateRangeType = BriefingDateRangeTypeEnum.SPECIFIC;
            this.briefingsService.refreshBlockData(block);
        }
    }

    private canSave(): boolean {
        if (this.saveInProgress) {
            return false;
        }
        this.saveInProgress = true;
        this.setBriefing(this.briefing);
        if (this.allocatedMentionsCount > this.maxNumberOfMentionsInBriefing) {
            this.briefingsService.showMentionLimitReachedOnSaveDialog(this.allocatedMentionsCount);
            this.saveInProgress = false;
            return false;
        }

        if (!this.validate(this.draftErrors) || !this.briefingsService.validateBlockCount()) {
            this.saveInProgress = false;
            return false;
        }

        return true;
    }

    update(): void {
        this.saveInProgress = true;
        this.setBriefing(this.briefing);

        if (!this.briefingsService.validateBlockCount()) {
            this.saveInProgress = false;
            return;
        }

        switch (this.briefing.status) {
            case BriefingStatusEnum.ACTIVE:
                // If it's actively recurring, we need to validate it as if they were trying to start it again
                if (!this.validate(this.sendErrors)) {
                    this.saveInProgress = false;
                    return;
                }
                break;

            default:
                if (!this.validate(this.draftErrors)) {
                    this.saveInProgress = false;
                    return;
                }
                break;
        }
        this.briefingsService.setCurrentBriefing(this.briefing);
        // need to subscribe to observable for it run
        this.briefingsService.saveCurrentBriefing().subscribe({
            next: () => {
                this.isClean = true;
                this.saveInProgress = false;
                this.shouldActionsBeDisabled();
            },
            error: () => {
                this.saveInProgress = false;
                this.shouldActionsBeDisabled();
            }
        });
    }

    send(): void {
        if (this.allocatedMentionsCount > this.maxNumberOfMentionsInBriefing) {
            this.briefingsService.showMentionLimitReachedOnSendDialog(this.allocatedMentionsCount);
            return;
        }
        if (!this.validate(this.sendErrors)) {
            return;
        }
        this.setShowSendConfirmation(true);
    }

    start(): void {
        if (!this.validate(this.sendErrors)) {
            return;
        }
        this.setShowSendConfirmation(true);
    }

    cancel(): void {
        this.briefingsService.cancelCurrentBriefing().subscribe({
            error: (error) => {
                let errorMessage = 'Briefing.cancelBriefingErrorMessage.line2.generic';
                if (error && error.error && error.error.details) {
                    for (const errorDetail of error.error.details) {
                        if (errorDetail.code === BriefingsApiErrorEnum.tooLateToCancel) {
                            errorMessage = 'Briefing.cancelBriefingErrorMessage.line2.tooLate';
                            break;
                        }
                    }
                }
                this.openCancelErrorDialog(errorMessage);
                this.briefingsService.updateBriefingListItems();
            }
        });
    }

    setPublishingErrors(errors: StepsBannerErrorConfigModel[]) {
        this.publishingErrors = errors;
        this.setBannerErrorList(this.draftErrors);
    }

    setBannerErrorList(level: number) {
        this.compositionErrors = [];
        if (!this.validateBriefingBlocks(level)) {
            const result = this.briefingsService.getBlockErrors(this.briefing.blocks);
            for (let i = 0; i < result?.length; i++) {
                this.compositionErrors.push(
                    {
                        errorId: result[i].id,
                        label: result[i].label,
                        tab: BriefingStepsEnum.compose
                    }
                );
            }
            if (this.showNoBlocksSelectedErrorMsg) {
                this.compositionErrors.push(
                    {
                        errorId: 'noBlocksError',
                        label: 'Briefings.error.blockRequired',
                        tab: BriefingStepsEnum.compose
                    }
                );
            }
        }

        this.bannerErrorList = [...this.compositionErrors, ...this.publishingErrors];

        const isRssFeedError = this.bannerErrorList.find(error => error.errorId === BriefingBannerErrorIdEnum.rssFeed);

        let canSaveBriefing = true;
        if (isRssFeedError || this.hasChartBlockImageSizeError) {
            canSaveBriefing = false;
        }
        this.canSaveBriefing = canSaveBriefing;
        this.shouldActionsBeDisabled();
    }

    toggleAutoGenExpanded(event: boolean) {
        this.isAutoGenBannerExpanded = !event;
    }

    openCancelErrorDialog(text: string): void {
        this.coreDialogService.open(
            ConfirmDialogComponent,
            <ConfirmDialogModel>{
                inputs: {
                    heading: 'Briefing.cancelBriefingErrorHeading',
                    okLabel: 'Briefing.cancelBriefingErrorMessage.okButtonLabel',
                    showCancel: false,
                    width: 350,
                    alertType: messageSeverityEnum.error,
                    alertMessage: {
                        key: 'Briefing.cancelBriefingErrorMessage.line1',
                        args: { name: this.briefing.name }
                    },
                    message: text
                },
                outputs: {
                    dialogClose: () => this.briefingsService.refreshCurrentBriefing()
                }
            }
        );
    }

    /**
     * Handles changes in the replyTo text input
     *
     * @param event the contents of the text input
     */
    replyToChanged(event): void {
        this.replyToEmailValid = true;
        this.showReplyToErrorMsg = false;
        this.showReplyToEmailLengthErrorMsg = false;
        // empty string is valid for saving draft
        if (event?.trim() !== '') {
            this.replyToEmailValid = validateEmails(event);
            if (!this.replyToEmailValid) {
                this.showReplyToErrorMsg = true;
            }
        }
        if (event?.length === this.maxInputTextLength) {
            this.showReplyToEmailLengthErrorMsg = true;
        }
        this.briefingChanged();
    }


    /**
     * Detects changes and sets isClean accordingly
     */
    public briefingChanged(): void {
        this.checkRecurringDateRange();
        this.setIsClean(this.briefing.equals(this.briefingsService.getCachedCurrentBriefing()));
        this.shouldActionsBeDisabled();
    }

    /**
     * Validates briefing name
     *
     * @returns boolean
     */
    public isValidBriefingName(): boolean {
        let isValid = true;

        if (!this.isNameValid()) {
            isValid = false;
        }
        if (this.isNameDuplicate()) {
            isValid = false;
        }

        return isValid;
    }

    /**
     * Checks if briefing is unnamed, and sets error
     *
     * @returns boolean
     */
    public isNameValid(): boolean {
        this.validBriefingName = true;

        if (!this.briefing.name || this.briefing.name.trim() === '') {
            this.validBriefingName = false;
        }

        return this.validBriefingName;
    }

    /**
     * Checks if briefing name already exists, and sets error
     *
     * @returns boolean
     */
    public isNameDuplicate(): boolean {
        if (this.briefing && this.briefing.name) {
            this.duplicateBriefingName = this.briefingsService.isBriefingNameDuplicate(this.briefing.name, this.briefing.id);
            return this.duplicateBriefingName;
        }

        return false;
    }

    /**
     * Set method for briefing to handle mapping to scheduler fields
     */
    private setBriefing(briefing: BriefingModel, setFeed: boolean = true) {
        if (this.briefing?.id !== briefing?.id || this.briefing !== briefing) {
            this.cachedCanvasPreview = briefing.canvasPreview
                ? new OnlineBriefingTemplateConfigModel(briefing.canvasPreview.toApiString())
                : null;
            if (this.selectedTabIndex !== this.pdfTabIndex) {
                // reset the page when the selected briefing changes
                this.selectedTabIndex = this.defaultSelectedTabIndex;
            }
            this.showErrorsLevel = this.noErrors;
        }
        // if you have added or deleted a block reset error level
        if (this.briefing?.blocks.length !== briefing.blocks.length) {
            this.showErrorsLevel = this.noErrors;
        }
        this.briefing = briefing;
        this.setReservedURL();

        this.isScheduled = this.briefing.status === BriefingStatusEnum.SCHEDULED;
        this.editable = !this.isScheduled;

        // Refactor this when doing rxjs implementation
        if (setFeed) {
            this.rssFeedService.getByIds(this.briefing.getFeedIds()).subscribe(rssFeeds => {
                this.briefing?.setFeedNameAndUrl(rssFeeds);
            });
        }

        this.setBriefingDetails();

        if (this.briefing.sendAt.sendNow) {
            this.deliverySchedulerInputFields.deliveryDate = new Date();
            this.deliverySchedulerInputFields.deliveryTime = {
                format: this.preferences?.timeFormat,
                hour: null,
                minute: null,
                timeZone: this.briefing.sendAt.timeZone
            };
            this.deliverySchedulerInputFields.recurrenceModel = new BriefingRecurrencePatternModel();
            this.deliverySchedulerInputFields.recurrenceModel.timeZone = this.briefing.sendAt.timeZone;
            this.deliverySchedulerInputFields.schedulingType = deliverySchedulingTypesEnum.immediate;
        } else if (this.briefing.sendAt.sendLater) {
            this.deliverySchedulerInputFields.deliveryDate = new Date(this.briefing.sendAt.sendLater);
            this.deliverySchedulerInputFields.deliveryTime = this.timeHelper.getTimeFromDate(
                this.deliverySchedulerInputFields.deliveryDate,
                this.briefing.sendAt.timeZone,
                this.preferences?.timeFormat
            );

            this.deliverySchedulerInputFields.recurrenceModel = new BriefingRecurrencePatternModel();
            this.deliverySchedulerInputFields.recurrenceModel.timeZone = this.briefing.sendAt.timeZone;
            this.deliverySchedulerInputFields.schedulingType = deliverySchedulingTypesEnum.future;
        } else {
            this.deliverySchedulerInputFields.deliveryDate = new Date();
            this.deliverySchedulerInputFields.deliveryTime = {
                format: this.preferences?.timeFormat,
                hour: null,
                minute: null,
                timeZone: this.briefing.sendAt.timeZone
            };
            this.deliverySchedulerInputFields.recurrenceModel = this.briefing.sendAt.recurring;
            this.deliverySchedulerInputFields.recurrenceModel.timeZone = this.briefing.sendAt.timeZone;
            this.deliverySchedulerInputFields.schedulingType = deliverySchedulingTypesEnum.recurring;
        }

        this.cachedSchedulingType = this.deliverySchedulerInputFields.schedulingType;
        if (this.showSendConfirmationOnLoad && (this.reservedUrl || this.briefing.sendAt.recurring)) {
            this.setShowSendConfirmation(true);
            this.briefingsService.showSendConfirmationOnLoad(false);
        }
    }


    /**
     * Method for managing the state of the briefing being currently edited
     */
    private setIsClean(bool: boolean) {
        this.isClean = bool;
    }

    /**
     * Handles selected mentions changing from the sort tool
     *
     * @param event
     */
    public selectedMentionChange(event): void {
        this.mentionsSelected = event;
    }


    openManuallyAddMentionDialog(block?: BlockModel) {
        const overlayContainer = document.getElementById('main-content');
        const animationTrigger = new BehaviorSubject(
            new FullProfileAnimationModel(
                FullProfileDialogAnimationsEnum.slideInOutAnimation,
                OverlayAnimationStateEnum.open
            )
        );
        const io = {
            inputs: {
                animationTrigger: animationTrigger,
                overlayContainer: overlayContainer,
                block: block
            }
        };
        this.coreDialogService.open(ManuallyAddCoverageDialogComponent, io);
    }

    /**
     * Shows the automatically add coverage dialog
     */
    public automaticallyAddMentions() {
        this.coreDialogService.open(AutomaticCoverageDialogComponent);
    }

    /**
     * Confirmation modal
     */

    /**
     * Shows the confirmation modal
     */
    public setShowSendConfirmation(show: boolean): Promise<void> {
        this.confirmationDialogMetadata = [];
        if (!show) {
            return;
        }

        // We want to show a confirmation to save dialog before we show the confirm to send dialog to deal with an issue of over-saving briefings
        const isSaved = this.briefing.id !== null;
        if (!(this.isClean && isSaved)) {
            const confirmDialogModel: ConfirmDialogModel = {
                inputs: {
                    heading: 'Monitor.results.briefingNeedsSaved.heading',
                    message: 'Monitor.results.briefingNeedsSaved.message',
                    okLabel: 'Monitor.results.briefingNeedsSaved.acknowledge'
                },
                outputs: {
                    dialogClose: (confirm: boolean) => {
                        if (confirm) {
                            this.saveAsDraft(true);
                        }
                    }
                }
            };
            this.coreDialogService.open(ConfirmDialogComponent, confirmDialogModel);
            return;
        }

        let deliveryTime = '';

        if (this.briefing.sendAt.sendNow) {
            deliveryTime = this.localizationService.transform('Briefings.confirmationDialog.legalDisclaimer.immediately');
        } else if (this.briefing.sendAt.sendLater) {
            deliveryTime = this.localizationService.transform('Briefings.confirmationDialog.legalDisclaimer.scheduled', {
                scheduledTime: this.briefing.sendAt.getDisplayString()
            });
        } else {
            deliveryTime = this.localizationService.transform('Briefings.confirmationDialog.legalDisclaimer.recurring', {
                recurrence: this.briefingSendNowHelper.getRecurranceLocalization(this.briefing.sendAt), scheduledTime: this.briefing.sendAt.getDisplayString()
            });
        }

        const io: PublishStoryDialogModel = {
            inputs: {
                id: 'briefings.publishStoryDialog',
                header: 'Briefings.sendBriefing',
                headerIcon: 'fa-kit-duotone fa-agpr-briefings',
                metadata: null,
                storyInfo: false,
                localization: this.confirmationDialogLocalization,
                disclaimers: [this.localizationService.transform('Briefings.confirmationDialog.legalDisclaimer', {deliveryTime: deliveryTime})]
            },
            outputs: {
                dialogClose: (confirmed: boolean) => {
                    if (confirmed) {
                        requestAnimationFrame(() => {
                            this.isSending = true;
                        });
                        this.confirmSend();
                    }
                }
            }
        };
        this.coreDialogService.open(PublishStoryComponent, io);
    }

    /**
     * Sends the current briefing as it's been confirmed by the user
     */
    public confirmSend(): void {
        this.submitInProgress = true;
        this.briefingsService.sendCurrentBriefing().subscribe({
            next: () => {
                // TODO: Success message for user
                this.setShowSendConfirmation(false);
                this.submitInProgress = false;
            },
            error: () => {
                // TODO: Error message for user
                this.isSending = false;
                this.submitInProgress = false;
                this.setShowSendConfirmation(false);
            }
        });
    }

    /**
     * Validates the current briefing data
     * @param level The level of validation to perform
     */
    public validate(level: number): boolean {
        let valid = true;
        this.showErrorsLevel = level;
        this.getDeliveryDateErrorMessages();
        this.showNoBlocksSelectedErrorMsg = false;
        this.showMailingListError = false;

        if (level >= this.draftErrors) {
            if (this.briefing?.selectedDeliveryOption?.rssFeed) {
                if (this.briefing.feeds.length === 0) {
                    valid = false;
                }
            }
        }

        const hasBlockErrors = !this.validateBriefingBlocks(level);

        // equality to avoid running this in the normal 'send' case
        if (level === this.sendPreviewErrors) {
            this.replyToChanged(this.briefing.replyTo);
            if (
                hasBlockErrors
                || !this.briefing.replyTo
                || this.briefing.replyTo.trim() === ''
                || this.showReplyToErrorMsg
            ) {
                valid = false;
            }
        }

        if (level >= this.sendErrors) {
            this.replyToChanged(this.briefing.replyTo);

            if (this.briefing?.selectedDeliveryOption?.email) {
                if (!this.briefing.subject
                    || this.briefing.subject.trim() === ''
                    || !this.briefing.fromName
                    || this.briefing.fromName.trim() === ''
                    || !this.briefing.replyTo
                    || this.briefing.replyTo.trim() === ''
                    || this.showReplyToErrorMsg
                    || (this.briefing.deliveryMethod !== BriefingDeliveryMethodEnum.ONLINE // Total recipient count is not checked for Canvas
                        && !this.briefing.recipientList?.length
                        && !this.briefing.mailingListIds?.length)
                    || (!!this.briefing.mailingListIds?.length && this.mailingListsService.getRecipientCount(this.briefing.mailingListIds) === 0)
                ) {
                    valid = false;

                    if (!!this.briefing.mailingListIds?.length && this.mailingListsService.getRecipientCount(this.briefing.mailingListIds) === 0) {
                        this.showMailingListError = true;
                    }
                }
            }

            if (this.briefing?.selectedDeliveryOption?.rssFeed) {
                if (this.briefing.feeds.length === 0) {
                    valid = false;
                }
            }

            if (!this.briefing?.selectedDeliveryOption?.rssFeed && !this.briefing?.selectedDeliveryOption?.email) {
                valid = false;
            }

            if (
                hasBlockErrors
                || this.deliverySchedulerMessages.length > 0
                || this.deliveryDateInPast()
            ) {
                if (this.deliverySchedulerMessages.length > 0) {
                    this.schedulingError.label = this.deliverySchedulerMessages[0].summary;
                }
                if (this.deliveryDateInPast()) {
                    this.schedulingError.label = 'Briefings.error.minDateTooEarly';
                }
                valid = false;
            } else {
                this.schedulingError = new StepsBannerErrorConfigModel();
            }
        }

        this.showErrors = !valid;
        if (this.showErrors) {
            this.setBannerErrorList(level);
            requestAnimationFrame(() => {
                (document.querySelector('.agpr-briefing-bannerMessage .agpr-message-toggleIcon') as HTMLElement)?.focus();
            });
        }

        return valid;
    }

    /**
     * Gets an array of errors related to the delivery scheduler based on
     * publish status, the date field, and time fields
     */
    public getDeliveryDateErrorMessages(): void {
        if (this.showErrorsLevel < this.sendErrors) {
            this.deliverySchedulerMessages = [];
        }
        const errorMessages: MessageModel[] = [];

        if (this.deliverySchedulerInputFields.schedulingType === deliverySchedulingTypesEnum.future) {
            const scheduledDate = this.deliverySchedulerInputFields.deliveryDate;
            const scheduledTime = this.deliverySchedulerInputFields.deliveryTime;

            const hasDate: boolean = scheduledDate !== null && scheduledDate !== undefined;
            const hasHour: boolean = scheduledTime && scheduledTime.hour !== null && scheduledTime.hour !== undefined;
            const hasMinute: boolean = scheduledTime && scheduledTime.minute !== null && scheduledTime.minute !== undefined;
            const hasTimezone: boolean = scheduledTime && scheduledTime.timeZone !== null && scheduledTime.timeZone !== undefined;

            if (!hasDate) {
                errorMessages.push({
                    severity: messageSeverityEnum.error,
                    summary: this.localizationService.transform('Briefings.error.missingDateInformation')
                } as MessageModel);
            }

            if (!hasHour) {
                errorMessages.push({
                    severity: messageSeverityEnum.error,
                    summary: this.localizationService.transform('Briefings.error.missingHourInformation')
                } as MessageModel);
            }

            if (!hasMinute) {
                errorMessages.push({
                    severity: messageSeverityEnum.error,
                    summary: this.localizationService.transform('Briefings.error.missingMinuteInformation')
                } as MessageModel);
            }

            if (!hasTimezone) {
                errorMessages.push({
                    severity: messageSeverityEnum.error,
                    summary: this.localizationService.transform('Briefings.error.invalidTimeFormat')
                } as MessageModel);
            }
        } else if (this.deliverySchedulerInputFields.schedulingType === deliverySchedulingTypesEnum.recurring) {
            const recurrence = this.deliverySchedulerInputFields.recurrenceModel as BriefingRecurrencePatternModel;
            if (!recurrence.frequencyType) {
                errorMessages.push({
                    severity: messageSeverityEnum.error,
                    summary: this.localizationService.transform('Briefings.error.noRecurrenceType')
                } as MessageModel);
            }
            // Quarterly publishes on a fixed set of months/days and doesn't use day selection,
            // so it intentionally has no frequencyValues.
            if (recurrence.frequencyType !== BriefingRecurrenceFrequencyEnum.quarterly && recurrence.frequencyValues.length === 0) {
                errorMessages.push({
                    severity: messageSeverityEnum.error,
                    summary: this.localizationService.transform('Briefings.error.noDaysPicked')
                } as MessageModel);
            }
            if (recurrence.times.length === 0) {
                errorMessages.push({
                    severity: messageSeverityEnum.error,
                    summary: this.localizationService.transform('Briefings.error.noTimesPicked')
                } as MessageModel);
            } else {
                for (const timeValue of recurrence.times) {
                    if (!timeValue.isValidTime() || timeValue.timeZone === null || timeValue.timeZone === undefined) {
                        errorMessages.push(
                            {
                                severity: messageSeverityEnum.error,
                                summary: this.localizationService.transform(('Briefings.error.invalidTimeFormat'))
                            } as MessageModel
                        );
                        break;
                    }
                }
            }
        }

        this.deliverySchedulerMessages = errorMessages;
    }

    /**
     * Returns true if sendLater is set and is in the past, else, false
     */
    private deliveryDateInPast(): boolean {
        if (this.briefing && this.briefing.sendAt && this.briefing.sendAt.sendLater) {
            return this.briefing.sendAt.sendLater < this.deliverySchedulerInputFields.minDate;
        }

        return false;
    }

    /**
     * Sets the attributes for the Scheduled BriefingDetails attribute list
     */
    setScheduledDetails(): void {
        if (!this.isScheduled || !this.preferences) {

            return;
        }

        const dateSentAttribute: AttributeModel = {
            id: SentBriefingEnum.dateSent,
            label: 'Briefing.dateScheduled',
            value: this.briefing.sendAt.getDisplayString(this.preferences.getDateFormatString(true, true)),
            type: attributeTypesEnum.simple
        };

        const subjectLineAttribute: AttributeModel = {
            id: SentBriefingEnum,
            label: 'Briefings.input.subjectLine',
            value: this.briefing.subject,
            type: attributeTypesEnum.simple
        };

        const fromName: AttributeModel = {
            id: SentBriefingEnum.fromName,
            label: 'Briefings.input.fromName',
            value: this.briefing.fromName,
            type: attributeTypesEnum.simple
        };

        const replyTo: AttributeModel = {
            id: SentBriefingEnum.replyTo,
            label: 'Briefings.input.replyTo',
            value: this.briefing.replyTo,
            type: attributeTypesEnum.simple
        };

        let recipients: AttributeModel = new AttributeModel();
        if (!(this.briefing.recipientList == null) && this.briefing.recipientList?.length !== 0) {
            recipients = {
                id: SentBriefingEnum.recipients,
                label: 'Briefings.input.recipients',
                value: this.briefing.recipientList,
                type: attributeTypesEnum.simpleList
            };
        }

        // only put mailing list name for now, because the recipients inside the lists might have changed, so it would mislead the users.
        // It will require a backend change to make it valid later on.
        let mailingLists: AttributeModel = new AttributeModel();
        if (this.briefing.mailingListIds?.length > 0) {
            const len = this.briefing.mailingListIds?.length;
            const listNames = this.mailingLists?.filter(list => this.briefing.mailingListIds.includes(list.id))
                .map((list) => list.name);

            mailingLists = {
                id: SentBriefingEnum.recipients,
                label: 'Briefings.input.mailingLists',
                value: listNames,
                type: attributeTypesEnum.simpleList
            };
        }

        const feeds: AttributeModel = {
            id: SentBriefingEnum.rssFeeds,
            label: 'Briefings.confirmationDialog.rssFeeds',
            value: null,
            type: attributeTypesEnum.customList,
            customTemplate: this.rssFeedSentDetails,
            message: { summary: 'Briefing.copyFeedUrlMesage.summary', detail: 'Briefing.copyFeedUrlMessage.detail' }
        };
        if (this.briefing.feeds?.length) {
            feeds.value = this.briefing.feeds;
        }

        const reservedUrl: AttributeModel = {
            id: SentBriefingEnum.reservedUrl,
            label: 'Briefings.confirmationDialog.url',
            value: this.reservedUrl,
            url: this.reservedUrl,
            type: attributeTypesEnum.url
        };

        this.sentDetails = [
            dateSentAttribute,
            subjectLineAttribute,
            fromName,
            replyTo,
            recipients,
            mailingLists,
            reservedUrl,
            feeds
        ];
    }

    /**
     * Sets the attributes for briefing details attribute list
     */
    public setBriefingDetails(): void {
        this.setScheduledDetails();

        if (!this.briefing) {
            this.briefingDetails = [];
            return;
        }

        this.briefingDetails = this.briefingsService.getBriefingDetails();
    }

    /**
     * Check the current briefing's blocks for errors
     *
     * @return boolean - true if no errors
     */
    public validateBriefingBlocks(level): boolean {
        let isValid = true;
        const blocks = this.briefing.blocks;
        if (level >= this.sendPreviewErrors) {
            if (!this.briefing.blocks.length && !this.loadingBriefing) {
                this.showNoBlocksSelectedErrorMsg = true;
                return false;
            } else {
                this.showNoBlocksSelectedErrorMsg = false;
            }
        }

        this.hasChartBlockImageSizeError = false;
        for (let i = 0; i < blocks.length; i++) {
            const block = blocks[i];
            let valid = true;
            if (block.isLayoutBlockType()) {
                (block as LayoutBlock).blocks.forEach(column => {
                    column.forEach(x => {
                        valid = this.validateBriefingBlock(x, level);
                        if (!valid) {
                            isValid = false;
                        }
                    });
                });
            } else if (block.type.key === BriefingBlockTypeEnum.COVERAGE_CURATOR) {
                let validateCuratorBlock = false;
                (block as CuratorBlock).blocks.forEach(x => {
                    if (!x.displayElement.automaticallyGenerated) {
                        valid = this.validateBriefingBlock(x, level);
                        if (!valid) {
                            isValid = false;
                        }
                    } else {
                        validateCuratorBlock = true;
                    }
                });

                // if all the blocks are set to "manual", then we do not have to do validation on the curator block itself
                if (validateCuratorBlock || (block as CuratorBlock).blocks?.length === 0) {
                    valid = this.validateBriefingBlock(block, level);
                    if (!valid) {
                        isValid = false;
                    }
                }
            } else {
                valid = this.validateBriefingBlock(block, level);
                if (!valid) {
                    isValid = false;
                }
            }
        }

        return isValid;
    }

    public validateBriefingBlock(block: BlockModel, level: number): boolean {
        let isValid = true;
        switch (block.type.key) {
            case BriefingBlockTypeEnum.TITLE:
            case BriefingBlockTypeEnum.TEXT:
                isValid = this.checkErrorsForTextOrTitle(block, level) && isValid;
                break;
            case BriefingBlockTypeEnum.IMAGE:
                isValid = this.imageBlockIsValid(block, level) && isValid;
                break;
            case BriefingBlockTypeEnum.DATE:
            case BriefingBlockTypeEnum.CURATED_MENTION_LIST:
                break;
            case BriefingBlockTypeEnum.AUTOMATIC_MENTION_LIST:
                isValid = this.checkErrorsForAutomaticMentionList(block, true, level) && isValid;
                break;
            case BriefingBlockTypeEnum.ANALYSIS:
                isValid = this.checkErrorsForAutomaticMentionList(block, false, level) && this.checkErrorsForAnalysisBlock(block, level) && isValid;
                break;
            case BriefingBlockTypeEnum.LINK:
                isValid = this.checkErrorsForLinkBlock(block, level) && isValid;
                break;
            case BriefingBlockTypeEnum.CHART:
                isValid = this.checkErrorsForChartBlock(block, level) && isValid;
                break;
            case BriefingBlockTypeEnum.COVERAGE_CURATOR:
                isValid = this.checkErrorsForAutomaticMentionList(block, false, level) &&
                    this.checkErrorsForCuratorBlock(block as CuratorBlock, level) && isValid;
                break;
        }

        return isValid;
    }

    /**
     * Check for errors on blocks of type text or title
     *
     * @param block the item to check for errors on
     *
     * @returns boolean - true if no errors
     */
    private checkErrorsForTextOrTitle(block: BlockModel, level: number): boolean {
        if (level <= this.draftErrors) {
            return true;
        }
        const displayElement = block.displayElement as TextDisplayElementModel;

        if ((!displayElement.text || !displayElement.text.trim()) && block.type.key === BriefingBlockTypeEnum.TEXT) {
            const errorMsg = 'Briefings.error.textRequired';
            this.addErrorMsg(errorMsg, block.errors);

            return false;
        }
        if ((!displayElement.text || !displayElement.text.trim()) && block.type.key === BriefingBlockTypeEnum.TITLE) {
            const errorMsg = 'Briefings.error.titleRequired';
            this.addErrorMsg(errorMsg, block.errors);

            return false;
        }
        block.errors = [];

        return true;
    }

    /**
     * Check for errors on an image block
     *
     * @param block the item to check for errors on
     *
     * @returns boolean - true if no errors
     */
    private imageBlockIsValid(block: BlockModel, level: number): boolean {
        if (level <= this.draftErrors) {
            return true;
        }

        const imageDisplayElement = (block.displayElement as BriefingImageDisplayElementModel);
        if (imageDisplayElement?.images?.length) {
            for (const image of imageDisplayElement?.images) {
                const urlString = image?.url;
                // Empty or unset url doesn't need to be validated.
                if ((!urlString || urlString.trim().length === 0) && image.imageSource !== ImageSourceEnum.AUTOMATE) {
                    const errorMsg = 'Briefings.error.imageRequired';
                    this.addErrorMsg(errorMsg, block.errors);

                    return false;
                }

                if (image.imageSource !== ImageSourceEnum.AUTOMATE) {
                    try {
                        // Pass a base so protocol-relative (//host/path) and other
                        // browser-resolvable URLs validate the same way <img> resolves them.
                        new URL(urlString, window.location.origin);
                    } catch {
                        const errorMsg = 'Briefings.error.invalidImageUrl';
                        this.addErrorMsg(errorMsg, block.errors);

                        return false;
                    }
                }

            };
        } else {
            // no images added
            const errorMsg = 'Briefings.error.imageRequired';
            this.addErrorMsg(errorMsg, block.errors);

            return false;
        }

        block.errors = [];

        return true;
    }

    /**
     * Check for errors on dynamic mention block
     *
     * @param block the item to check errors on
     *
     * @returns boolean - true if no errors
     */
    private checkErrorsForAutomaticMentionList(block: BlockModel, includePageSize: boolean = true, level: number): boolean {
        if (level <= this.draftErrors) {
            return true;
        }

        const displayElement = block.displayElement as DynamicMentionListDisplayElementModel;
        if (!displayElement.backendDataSource && displayElement.backendDataSource.type !== MonitoringSeriesTypeEnum.allSavedCoverage) {
            const errorMsg = 'Briefings.error.topicRequired';
            this.addErrorMsg(errorMsg, block.errors);

            return false;
        }

        // if generate now selected, we don't need a source
        if (block.type.key === BriefingBlockTypeEnum.ANALYSIS) {
            if (!(block.displayElement as AnalysisDisplayElementModel).generateOnSend) {
                return true;
            } else {
                this.checkToClearAnalysisErrors(block);
            }
        }

        if (
            displayElement.additionalSettings?.autoGenInsight &&
            displayElement.additionalSettings.autoGenInsight.completionFormat === `${ChatMessageTypeModel.MENTION_INSIGHTS}_${MentionInsightTypes.CUSTOM}` &&
            !displayElement.additionalSettings.autoGenInsight.customPromptId
        ) {
            this.addErrorMsg('Briefings.analysis.errors.customPromptIsRequired', block.errors);
            return false;
        }

        if (
            displayElement.additionalSettings?.precisionClip &&
            displayElement.additionalSettings.precisionClip.savedMentionKeywords === false &&
            displayElement.additionalSettings.precisionClip.manualKeywords?.length === 0
        ) {
            this.addErrorMsg('Briefings.analysis.errors.noManualKeywords', block.errors);
            return false;
        }

        if (includePageSize) {
            if (
                !displayElement
                || !displayElement.pageSize
                || displayElement.pageSize < 1
                || displayElement.pageSize > 1000
            ) {
                const errorMsg = 'Briefings.dynamicMentionsList.form.numberOfMentionsErrorMessage';
                this.addErrorMsg(errorMsg, block.errors);

                return false;
            }
        }

        switch (displayElement.backendDataSource.type) {
            case MonitoringSeriesTypeEnum.allSavedCoverage:
            case MonitoringSeriesTypeEnum.allCuratedCoverageInBrief:
                // There's no situation that this option is invalid.
                break;

            case MonitoringSeriesTypeEnum.topic:
                if (this.topics && !this.topics.find(savedSearch => savedSearch.id === displayElement.backendDataSource.id)) {
                    this.addErrorMsg('Briefings.dynamicMentionsList.form.noDataSourceSelected', block.errors);

                    return false;
                }
                break;

            case MonitoringSeriesTypeEnum.folder:
                if (this.folders && !this.folders.find(folder => folder.id === displayElement.backendDataSource.id)) {
                    this.addErrorMsg('Briefings.dynamicMentionsList.form.noDataSourceSelected', block.errors);

                    return false;
                }
                break;

            case MonitoringSeriesTypeEnum.tag:
                if (this.tags && !this.tags.find(tag => tag.id === displayElement.backendDataSource.id)) {
                    this.addErrorMsg('Briefings.dynamicMentionsList.form.noDataSourceSelected', block.errors);

                    return false;
                }
                break;

            case MonitoringSeriesTypeEnum.tagGroup:
                if (this.tagGroups && !this.tagGroups.find(tagGroup => tagGroup.id === displayElement.backendDataSource.id)) {
                    this.addErrorMsg('Briefings.dynamicMentionsList.form.noDataSourceSelected', block.errors);

                    return false;
                }
                break;

            case MonitoringSeriesTypeEnum.subscription:
                if (this.mediaSubscriptions
                    && !this.mediaSubscriptions.find(mediaSubscription => mediaSubscription.id === displayElement.backendDataSource.id)) {
                    this.addErrorMsg('Briefings.dynamicMentionsList.form.noDataSourceSelected', block.errors);

                    return false;
                }
                break;
            case MonitoringSeriesTypeEnum.sourceGroup:
                if (this.sourceGroups
                    && !this.sourceGroups.find(sourceGroup => sourceGroup.id === displayElement.backendDataSource.id)) {
                    this.addErrorMsg('Briefings.dynamicMentionsList.form.noDataSourceSelected', block.errors);

                    return false;
                }
                break;
            case MonitoringSeriesTypeEnum.socialTopic:
                if (this.socialTopics &&
                    !this.socialTopics.find(socialTopic => socialTopic.id === displayElement.backendDataSource.id)) {
                    this.addErrorMsg('Briefings.dynamicMentionsList.form.noDataSourceSelected', block.errors);

                    return false;
                }
                break;
            case MonitoringSeriesTypeEnum.theme:
                if (this.socialThemes
                    && !this.socialThemes.find(theme => theme.id === displayElement.backendDataSource.id)) {
                    this.addErrorMsg('Briefings.dynamicMentionsList.form.noDataSourceSelected', block.errors);

                    return false;
                }
                break;
            case MonitoringSeriesTypeEnum.aiAgent:
                if (this.aiAgents
                    && !this.aiAgents.find(aiAgent => aiAgent.id === displayElement.backendDataSource.id)) {
                    this.addErrorMsg('Briefings.dynamicMentionsList.form.noDataSourceSelected', block.errors);

                    return false;
                }
                break;

            case MonitoringSeriesTypeEnum.coverageInSection:
                if (this.mentionBlocks &&
                    !this.mentionBlocks.find(mentionBlock => {
                        return (mentionBlock.displayElement as DynamicMentionListDisplayElementModel)?.blockReferenceId ===
                            displayElement.backendDataSource.referenceId;
                    })
                ) {
                    this.addErrorMsg('Briefings.dynamicMentionsList.form.noDataSourceSelected', block.errors);

                    return false;
                }
                break;

            default:
                throw new Error(`unknown monitoring series type ${displayElement.backendDataSource.type}`);
        }

        if (block.type.key !== BriefingBlockTypeEnum.ANALYSIS) {
            block.errors = [];
        }
        return true;
    }


    /**
     * because we only want to show the analysis block errors on send.. we have to do this check when we don't send (ex: save or edit the brief)
     * if there is an error showing when you click send.. and they fix it, that error should be cleared (not stay there until you send)
     */
    checkToClearAnalysisErrors(block: BlockModel) {
        const displayElement = block.displayElement as AnalysisDisplayElementModel;
        if (displayElement.generateOnSend) {
            if (displayElement.analysisField) {
                if (!displayElement.analysisField.aiAnalysisType) {
                    return;
                }

                if (displayElement.analysisField.aiAnalysisType !== AiAnalysisTypes.CUSTOM) {
                    if (displayElement.analysisField.aiAnalysisType === AiAnalysisTypes.EXECUTIVE_SUMMARY) {
                        if (!displayElement.analysisField.selectedLengthOption) {
                            return;
                        }
                    } else if (displayElement.analysisField.aiAnalysisType === AiAnalysisTypes.BRAND_IMPACT) {
                        if (!displayElement.analysisField.brand) {
                            return;
                        }
                    }
                    if (!displayElement.analysisField.selectedLanguageOption) {
                        return;
                    }
                } else {
                    if (!displayElement.analysisField.customPromptId) {
                        this.addErrorMsg('Briefings.analysis.errors.customPromptIsRequired', block.errors);
                        return false;
                    }
                }
            }
        } else {
            if (!displayElement.text) {
                return;
            }
        }
        block.errors = [];
    }

    /**
     * Check for errors on analysisblock
     *
     * @param block the item to check errors on
     *
     * @returns boolean - true if no errors
     */
    private checkErrorsForAnalysisBlock(block: BlockModel, level: number): boolean {
        if (level >= this.sendPreviewErrors) {
            const displayElement = block.displayElement as AnalysisDisplayElementModel;

            if (displayElement.generateOnSend) {
                if (displayElement.analysisField) {
                    if (!displayElement.analysisField.aiAnalysisType) {
                        this.addErrorMsg('Briefings.analysis.errors.mustSelectAnalysisType', block.errors);
                        return false;
                    }

                    if (displayElement.analysisField.aiAnalysisType !== AiAnalysisTypes.CUSTOM) {
                        if (displayElement.analysisField.aiAnalysisType === AiAnalysisTypes.EXECUTIVE_SUMMARY) {
                            if (!displayElement.analysisField.selectedLengthOption) {
                                this.addErrorMsg('Briefings.analysis.errors.mustSelectLength', block.errors);
                                return false;
                            }
                        } else if (displayElement.analysisField.aiAnalysisType === AiAnalysisTypes.BRAND_IMPACT) {
                            if (!displayElement.analysisField.brand) {
                                this.addErrorMsg('Briefings.analysis.errors.mustAddBrand', block.errors);
                                return false;
                            }
                        }
                        if (!displayElement.analysisField.selectedLanguageOption) {
                            this.addErrorMsg('Briefings.analysis.errors.mustSelectLanguage', block.errors);
                            return false;
                        }
                    } else {
                        if (!displayElement.analysisField.customPromptId) {
                            this.addErrorMsg('Briefings.analysis.errors.customPromptIsRequired', block.errors);
                            return false;
                        }
                    }
                }
            } else {
                if (!displayElement.text) {
                    this.addErrorMsg('Briefings.analysis.errors.mustGenerateAnalysis', block.errors);
                    return false;
                }
            }
            block.errors = [];
        }
        return true;
    }

    /**
     * Check for errors on Social Link block
     *
     * @param block the item to check errors on
     *
     * @returns boolean - true if no errors
     */
    private checkErrorsForLinkBlock(block: BlockModel, level: number): boolean {
        if (level <= this.draftErrors) {
            return true;
        }
        const displayElement = block.displayElement as LinkDisplayElementModel;
        block.errors = [];
        if (!displayElement.links || !displayElement.links.length) {
            this.addErrorMsg('Briefings.error.socialLinks.linkRequried', block.errors);
            return false;
        } else if (displayElement.links.some(link => !link.url)) {
            this.addErrorMsg('Briefings.error.socialLinks.linkUrlRequried', block.errors);
            return false;
        }
        return true;
    }

    /**
     * Check for errors on Chart block
     *
     * @param block the item to check errors on
     *
     * @returns boolean - true if no errors
     */
    private checkErrorsForChartBlock(block: BlockModel, level: number): boolean {
        const displayElement = block.displayElement as BriefingChartDisplayElementModel;
        block.errors = [];

        if (level >= this.draftErrors) {
            if (displayElement.chart.chartUrl?.length >= MAX_BASE_64_IMAGE_SIZE) {
                this.addErrorMsg('Briefings.error.chart.image.size', block.errors);
                this.hasChartBlockImageSizeError = true;
                return false;
            }
        }

        if (level >= this.sendPreviewErrors) {
            if (
                displayElement.chart.generateOnSend &&
                displayElement?.chart?.chartUrl &&
                !displayElement?.chart?.chartUrl?.includes('agilitypr.media')
            ) {
                delete displayElement.chart.chartUrl;
            }
        }

        if (level >= this.sendPreviewErrors && !displayElement.canRender()) {
            this.addErrorMsg('Briefings.error.chart.required', block.errors);
            return false;
        }

        return true;
    }

    /**
     * Check for errors on Curator block
     *
     * @param block the item to check errors on
     *
     * @returns boolean - true if no errors
     */
    private checkErrorsForCuratorBlock(block: CuratorBlock, level: number): boolean {
        if (level <= this.draftErrors) {
            return true;
        }
        const displayElement = block.displayElement as CuratorDisplayElement;
        block.errors = [];

        if (block.blocks?.length === 0) {
            this.addErrorMsg('Briefings.error.curator.curator.isEmpty', block.errors);
            return false;
        }

        if (!displayElement.generateOnSend && !displayElement.hasGeneratedContent) {
            this.addErrorMsg('Briefings.error.curator.curator.noContentGenerated', block.errors);
            return false;
        }

        return true;
    }

    /**
     * Appends an error message if its not already there
     */
    private addErrorMsg(errorMsg: string, errors: string[]) {
        if (errors.indexOf(errorMsg) === -1) {
            errors.push(errorMsg);
        }
    }

    public selectBlockEditTab(): void {
        requestAnimationFrame(() => {
            this.selectedTabIndex = this.blockFormTabIndex;
        });
    }

    public switchToExpertMode(): void {
        this.coreDialogService.open(
            ConfirmDialogComponent,
            <ConfirmDialogModel>{
                inputs: {
                    heading: 'Briefings.previewMode.expertMode.dialog.heading',
                    alertType: messageSeverityEnum.warning,
                    alertMessage: 'Briefings.previewMode.expertMode.dialog.warning',
                    message: 'Briefings.previewMode.expertMode.dialog.message',
                    okLabel: 'Briefings.previewMode.expertMode.dialog.confirm',
                },
                outputs: {
                    dialogClose: (confirmed: boolean) => {
                        if (!confirmed) {
                            return;
                        }
                        this.briefing.canvasPreview = null;
                        this.editable = !this.isScheduled;
                        this.briefingsService.setBriefingBlocksActionable(this.briefing);
                        this.briefingChanged();
                        this.selectedTabIndex = this.defaultSelectedTabIndex;
                        this.shouldActionsBeDisabled();
                    }
                }
            }
        );
    }

    public canvasSetupChanged(): void {
        if (this.briefing.canvasPreview) {
            // Compare against a re-revived snapshot so both operands go through the same
            // normalization. toApiString() drops runtime-only search fields (facets, paging,
            // sort, dateFacets) and the constructor re-applies defaults to them; comparing the
            // revived cache directly against the live model otherwise always differs on those
            // fields and shows a spurious "pending changes" banner.
            const currentSnapshot = new OnlineBriefingTemplateConfigModel(this.briefing.canvasPreview.toApiString());
            this.briefing.canvasPreview.isChanged = this.cachedCanvasPreview
                ? !this.cachedCanvasPreview.equals(currentSnapshot)
                : false;
        }
        this.briefingsService.formFieldUpdated();
    }

    public dismissCanvasChangedBanner(): void {
        this.briefing.canvasPreview.isChanged = false;
    }

    public generatePreview(): void {
        const options = this.briefing.canvasPreview;
        if (!options) {
            return;
        }

        if (!this.canvasTemplateSetup.validate()) {
            return;
        }

        const newBriefing = this.briefingsTemplateFactorService.getTemplate(options);

        this.briefing.blocks = newBriefing.blocks;
        this.briefing.generalStyles = newBriefing.generalStyles;
        this.briefing.sendAt = newBriefing.sendAt;
        this.briefing.canvasPreview = new OnlineBriefingTemplateConfigModel(JSON.stringify(options));
        this.briefing.canvasPreview.isChanged = false;
        this.cachedCanvasPreview = new OnlineBriefingTemplateConfigModel(this.briefing.canvasPreview.toApiString());

        this.briefingsService.setCurrentBriefing(this.briefing);

        const isRecurring = !!this.briefing.sendAt.recurring;

        if (options.template === OnlineBriefingTemplateEnum.ONLINE_BRIEFING_TEMPLATE_COMPETITOR) {
            this.generateCompetitorPreview(options, isRecurring);
        } else {
            this.generateDefaultPreview(options, isRecurring);
        }
    }

    private generateDefaultPreview(options: OnlineBriefingTemplateConfigModel, isRecurring: boolean): void {
        if (!isRecurring && !options.allowAi) {
            this.briefingsService.loadCanvasMentions(options);
        }

        if (!isRecurring && options.allowAi) {
            this.generateAiPreview();
        }
    }

    private generateCompetitorPreview(options: OnlineBriefingTemplateConfigModel, isRecurring: boolean): void {
        if (!isRecurring && !options.allowAi) {
            this.briefingsService.loadCanvasMentions(options);
        }

        if (!isRecurring && options.allowAi) {
            this.generateAiPreview();
        }
    }

    private generateAiPreview(): void {
        const aiAnalysisBlocks: BlockModel[] = [];
        this.briefing.blocks.forEach(block => {
            if (block.type.key === BriefingBlockTypeEnum.ANALYSIS) {
                aiAnalysisBlocks.push(block);
            }
            if (block.isLayoutBlockType()) {
                (block as LayoutBlock).blocks?.forEach(items => {
                    items?.forEach(item => {
                        if (item.type.key === BriefingBlockTypeEnum.ANALYSIS) {
                            aiAnalysisBlocks.push(item);
                        }
                    });
                });
            }
        });

        this.briefingCoverageAnalysisService.generateAiContentForBlocks(aiAnalysisBlocks.filter(block =>
            (block.displayElement as AnalysisDisplayElementModel).backendDataSource.type !== MonitoringSeriesTypeEnum.allCuratedCoverageInBrief)
        );

        const curatorBlocks = this.briefing.blocks.filter(x => x.type.key === BriefingBlockTypeEnum.COVERAGE_CURATOR);
        curatorBlocks.forEach(curatorBlock =>
            this.briefingCoverageAnalysisService.curatorAnalyze(curatorBlock as CuratorBlock, true)
        );

        this.briefingCoverageAnalysisService.setAnalysisBlockWithAllCuratedCoverage(
            aiAnalysisBlocks.filter(block =>
                (block.displayElement as AnalysisDisplayElementModel).backendDataSource.type === MonitoringSeriesTypeEnum.allCuratedCoverageInBrief)
        );
    }

    public applyCanvasCustomize(): void {
        const accentColor = this.briefing.canvasPreview.accentColor;
        const bannerStyle = this.briefing.canvasPreview.bannerStyle;
        const isRecurring = !!this.briefing.sendAt.recurring;

        this.briefing.generalStyles.accentColor = accentColor;
        this.briefing.generalStyles.mention.heading.color = accentColor;
        this.briefingsService.setGeneralStyles(this.briefing.generalStyles);

        const mentionBlockTypes = [
            BriefingBlockTypeEnum.CURATED_MENTION_LIST,
            BriefingBlockTypeEnum.AUTOMATIC_MENTION_LIST
        ];

        const imageFrame = bannerStyle === OnlineBriefingBannerStyleEnum.IMAGE_GRID
            ? BriefingImageFrameEnum.COLLAGE
            : BriefingImageFrameEnum.NO_FRAME;

        const firstImageBlock = this.findFirstImageBlock();
        this.briefing.blocks.forEach(block => {
            this.applyCanvasStylesToBlock(block, accentColor, imageFrame, isRecurring, mentionBlockTypes, block === firstImageBlock);
            if (block.isLayoutBlockType()) {
                (block as LayoutBlock).blocks.forEach(column =>
                    column.forEach(inner =>
                        this.applyCanvasStylesToBlock(inner, accentColor, imageFrame, isRecurring, mentionBlockTypes, inner === firstImageBlock)
                    )
                );
            } else if (block.type.key === BriefingBlockTypeEnum.COVERAGE_CURATOR) {
                (block as CuratorBlock).blocks.forEach(inner =>
                    this.applyCanvasStylesToBlock(inner, accentColor, imageFrame, isRecurring, mentionBlockTypes, inner === firstImageBlock)
                );
            }
        });

        if (this.briefing.canvasPreview?.template === OnlineBriefingTemplateEnum.ONLINE_BRIEFING_TEMPLATE_COMPETITOR) {
            const firstLayoutBlock = this.briefing.blocks.find(b => b.isLayoutBlockType()) as LayoutBlock;
            const brandTitleBlock = firstLayoutBlock?.blocks?.[1]?.find(b =>
                b.type.key === BriefingBlockTypeEnum.TITLE &&
                (b.displayElement as BriefingTitleDisplayElementModel).styles.color
            );
            if (brandTitleBlock) {
                (brandTitleBlock.displayElement as BriefingTitleDisplayElementModel).styles.color = accentColor;
                this.briefingsService.notifyBlockDisplayElementChanged(brandTitleBlock, true);
            }
        }

        if (firstImageBlock) {
            this.briefingsService.notifyBlockDisplayElementChanged(firstImageBlock, true);
        }

        if (!isRecurring) {
            this.briefingsService.setCoverageImage();
        }

        this.briefing.canvasPreview.isChanged = false;
        this.briefingsService.formFieldUpdated();
    }

    private findFirstImageBlock(): BlockModel | null {
        for (const block of this.briefing.blocks) {
            if (block.type.key === BriefingBlockTypeEnum.IMAGE) {
                return block;
            }
            if (block.isLayoutBlockType()) {
                for (const col of (block as LayoutBlock).blocks) {
                    const inner = col.find(b => b.type.key === BriefingBlockTypeEnum.IMAGE);
                    if (inner) {
                        return inner;
                    }
                }
            }
        }
        return null;
    }

    private applyCanvasStylesToBlock(
        block: BlockModel,
        accentColor: string,
        imageFrame: BriefingImageFrameEnum,
        isRecurring: boolean,
        mentionBlockTypes: BriefingBlockTypeEnum[],
        applyImageFrame: boolean = false
    ): void {
        if (mentionBlockTypes.includes(block.type.key as BriefingBlockTypeEnum) ||
            block.type.key === BriefingBlockTypeEnum.CHART) {
            if (mentionBlockTypes.includes(block.type.key as BriefingBlockTypeEnum)) {
                // Canvas mention blocks (e.g. inside the AI curator) are created unbound from global
                // styles, so applyGeneralStylesToBlock won't refresh their colors. Set the
                // accent-driven colors explicitly, matching how the template builds them: the
                // "View All Mentions" link uses accentColor and the headline uses heading.color.
                const mentionStyles = (block.displayElement as DynamicMentionListDisplayElementModel).styles;
                mentionStyles.accentColor = accentColor;
                if (mentionStyles.heading) {
                    mentionStyles.heading.color = accentColor;
                }
            }
            this.briefingsService.applyGeneralStylesToBlock(block);
        } else if (block.type.key === BriefingBlockTypeEnum.IMAGE) {
            const imageElement = block.displayElement as BriefingImageDisplayElementModel;
            imageElement.imageEffects.primaryColor = accentColor;
            if (applyImageFrame) {
                imageElement.imageEffects.imageFrame = imageFrame;
            }
            imageElement.imageEffects = cloneDeep(imageElement.imageEffects);

            if (applyImageFrame) {
                const targetCount = imageFrame === BriefingImageFrameEnum.COLLAGE ? 4 : 1;
                imageElement.images = [];
                if (isRecurring) {
                    for (let i = 0; i < targetCount; i++) {
                        const img = new BriefingImagePropertiesModel();
                        img.location = i;
                        img.imageSource = ImageSourceEnum.AUTOMATE;
                        imageElement.images.push(img);
                    }
                }
            }
        }
    }

    public preview(): void {
        if (this.allocatedMentionsCount > this.maxNumberOfMentionsInBriefing) {
            this.briefingsService.showMentionLimitReachedOnPreviewDialog(this.allocatedMentionsCount);
            return;
        }

        if (!this.validate(this.sendPreviewErrors)) {
            this.messageService.add({
                severity: messageSeverityEnum.error,
                summary: 'Briefing.preview.view.error.heading',
                detail: 'Briefing.preview.view.sendError.message',
            });
            return;
        }

        this.coreDialogService.open(
            BriefingPreviewDialogComponent,
            {
                inputs: {
                    briefing: this.briefing,
                }
            }
        );
    }

    public saveAsTemplate(): void {
        this.coreDialogService.open(BriefingSaveTemplateDialogComponent);
    }

    public saveAsCanvasTemplate(): void {
        this.coreDialogService.open(CanvasSaveTemplateDialogComponent, {
            inputs: { briefing: this.briefing }
        });
    }

    public setReservedURL(): void {
        this.reservedUrl = this.briefingsService.getReservedUrl();
    }

    publishDraft(): void {
        this.publishDraftInProgress = true;

        if (!this.briefing.id) {
            const io: NewResourceDialogModel = {
                inputs: {
                    id: 'nameBriefing',
                    heading: 'Briefing.nameBriefingDialog.heading',
                    okLabel: 'Briefing.confirm',
                    placeholder: 'Briefing.renameBriefingDialog.placeholder',
                    description: 'Briefing.renameBriefingDialog.description',
                    initialValue: this.briefing.name,
                    formValidator: (name: string) => {
                        if (this.briefingsService.isBriefingNameDuplicate(name)) {
                            return [
                                'Briefing.copyBriefingDuplicateNameErrorMessage'
                            ];
                        }

                        return [];
                    },
                    submit: (name: string, group?: DisplayGroupModel) => {
                        this.briefing.name = name;
                        this.briefing.groupId = group?.id;

                        return this.briefingsService.saveCurrentBriefing().pipe(
                            tap(() => {
                                this.isClean = true;
                                this.saveInProgress = false;
                            }),
                            mergeMap(() => {
                                return this.briefingsService.publishDraft(this.briefing.id);
                            }),
                            catchError((err) => {
                                this.saveInProgress = false;
                                throw err;
                            })
                        );
                    }
                },
                outputs: {
                    dialogClose: () => {
                        this.saveInProgress = false;
                        this.publishDraftInProgress = false;
                    }
                }
            };
            this.coreDialogService.open(NewResourceDialogComponent, io);
        } else {
            of(this.isClean).pipe(mergeMap(isClean => {
                if (!isClean) {
                    const io: ConfirmDialogModel = {
                        inputs: {
                            id: 'briefing.publishDraft.unsavedChangeDialog',
                            heading: 'DeactivateGuard.heading',
                            message: 'Briefings.reservedUrl.unsavedChanges',
                            okLabel: 'Briefings.reservedUrl.unsavedChanges.save'
                        },
                        outputs: {
                            dialogClose: () => { }
                        }
                    };
                    return this.coreDialogService.openWithObservable(ConfirmDialogComponent, io).pipe(mergeMap(confirm => {
                        if (confirm) {
                            if (this.canSave()) {
                                this.briefingsService.setCurrentBriefing(this.briefing);

                                return this.briefingsService.saveCurrentBriefing().pipe(map(x => {
                                    this.isClean = true;
                                    this.saveInProgress = false;

                                    return true;
                                }));
                            } else {
                                return of(false);
                            }
                        }
                    }));
                } else {
                    return of(true);
                }
            }),
            mergeMap(confirm => {
                if (confirm) {
                    return this.briefingsService.publishDraft(this.briefing.id);
                }
            }),
            catchError(x => {
                this.saveInProgress = false;
                this.publishDraftInProgress = false;
                this.generatingPDF = false;
                throw x;
            }),
            take(1)).subscribe(x => {
                this.publishDraftInProgress = false;
            });
        }
    }

    private setReservedUrlDetails(): void {

        const draftPublishedDate = moment(this.briefingHistory.submittedDate)
            .tz(this.preferences.timeZone)
            .format(this.preferences.getDateFormatString(true, true, true));
        // B.E set url expiry date 30 days after the published date
        const urlExpiryDate = moment(this.briefingHistory.submittedDate)
            .add(30, 'd').tz(this.preferences.timeZone)
            .format(this.preferences.getDateFormatString(true, true, true));

        const dateSubmittedAttribute: AttributeModel = {
            id: BriefingReservedUrlAttributes.draftPublished,
            label: 'Briefings.reservedUrl.draftPublished',
            value: draftPublishedDate,
            type: attributeTypesEnum.simple
        };

        const urlExpiryDateAttribute: AttributeModel = {
            id: BriefingReservedUrlAttributes.urlExpiry,
            label: 'Briefings.reservedUrl.urlExpiry',
            value: urlExpiryDate,
            type: attributeTypesEnum.simple
        };

        this.reservedUrlDetails = [
            dateSubmittedAttribute,
            urlExpiryDateAttribute,
        ];
    }

    onDraggingMentions(dragging: boolean) {
        this.draggingMentions = dragging;
    }

    changeStep(tabIndex: number) {
        this.currentStep = tabIndex;

        switch (this.currentStep) {
            case BriefingStepsEnum.publishingSettings:
                if (this.selectedTabIndex !== this.detailsTabIndex) {
                    requestAnimationFrame(() => {
                        this.selectedTabIndex = this.detailsTabIndex;
                    });
                }

                break;
            case BriefingStepsEnum.reviewSchedule:
                if (this.selectedTabIndex !== this.detailsTabIndex) {
                    requestAnimationFrame(() => {
                        this.selectedTabIndex = this.detailsTabIndex;
                    });
                }
                this.validate(this.sendErrors);
                this.getDeliveryDateErrorMessages();
                this.setBannerErrorList(this.sendErrors);
                break;
            default:
                this.selectedTabIndex = this.defaultSelectedTabIndex;
                break;
        }
    }

    checkIfHasAutoGenInsights() {
        this.requireAutomaticInsightGen = false;
        this.numAutoGenMentions = 0;

        this.checkIfBlocksHasAutomaticInsightGen(this.briefing?.blocks);
    }

    checkIfBlocksHasAutomaticInsightGen(blocks: BlockModel[]) {
        blocks.forEach(block => {
            if ((block as LayoutBlock).blocks && block.isLayoutBlockType()) {
                (block as LayoutBlock).blocks.forEach(layoutBlocks => {
                    this.checkIfBlocksHasAutomaticInsightGen(layoutBlocks);
                });
            }
            if (
                (block.type.key === BriefingBlockTypeEnum.AUTOMATIC_MENTION_LIST) &&
                (block.displayElement.hasOwnProperty('briefingAutoGenerateInsightRequest'))
            ) {
                this.requireAutomaticInsightGen = true;
                this.numAutoGenMentions += (block.displayElement as DynamicMentionListDisplayElementModel)?.pageSize || 0;
            }
        });

    }

    checkAutoGensStatus() {
        if (this.briefing?.id && this.allAutoGensStatus && this.allAutoGensStatus[this.briefing.id]) {
            this.autoGensStatus = this.allAutoGensStatus[this.briefing.id];
            if (!this.allAutoGensStatus[this.briefing.id].loading) {
                this.briefingChanged();
            }
        } else {
            this.autoGensStatus = null;
        }
    }

    rhpTabChange(): void {
        this.briefingsService.selectedBlockUpdated();
    }

    generatePDF() {
        if (!this.iframeElement) {
            this.iframeElement = document.getElementById('briefing_pdf_iframe') as HTMLIFrameElement;
        }
        // let the iframe load a bit before starting the PDF
        this.cd.detectChanges();

        this.coreDialogService.open(
            BriefingGeneratingPdfDialogComponent,
            {
                inputs: {
                    briefing: this.briefing,
                    iframeElement: this.iframeElement,
                    isClean: this.isClean,
                    briefingHistory: this.briefingHistory,
                    includeMentionsInPDF: this.includeMentionsInPDF
                },
                outputs: {
                    dialogClose: (confirmed: boolean) => {
                        this.iframeElement.src = '';
                        this.iframeElement = null;
                        this.generatingPDF = false;
                    }
                }
            }
        );
    }

    cancelPrecision() {
        this.precisionClipService.cancel(this.briefing.id, PrecisionResourceType.BRIEFING);
    }

    shouldActionsBeDisabled() {
        const saveBriefingAction = this.actions.find(action => {
            return action.value === BriefingsSplitButtonType.saveBriefing;
        });
        if (saveBriefingAction) {
            saveBriefingAction.disabled = !this.canSaveBriefing || this.isClean;
        }


        const refreshDataAction = this.actions.find(action => {
            return action.value === BriefingsSplitButtonType.refreshData;
        });
        if (refreshDataAction) {
            refreshDataAction.disabled = !this.hasDynamicElements;
        }
    }

    openRefreshDataDialog() {
        this.coreDialogService.open(
            ConfirmDialogComponent,
            <ConfirmDialogModel>{
                inputs: {
                    heading: 'Briefing.refreshData.dialog.heading',
                    alertType: messageSeverityEnum.warning,
                    alertMessage: 'Briefing.refreshData.dialog.warning',
                    message: 'Briefing.refreshData.dialog.message',
                    okLabel: 'Briefing.refreshData',
                },
                outputs: {
                    dialogClose: (confirmed: boolean) => {
                        if (confirmed) {
                            this.showRefreshDataProgressDialog();
                        }
                    }
                }
            }
        );
    }

    showRefreshDataProgressDialog() {
        this.progress = new ProgressModel();
        this.chartBlocksLoadedInProgressBar = [];
        this.progress.currentIndex = 0;
        this.progress.totalItems = 0;
        const clonedBriefing = cloneDeep(this.briefing);
        this.chartBlocks = [];

        for (const block of this.briefing?.blocks) {
            if (block.isLayoutBlockType()) {
                for (const column of (block as LayoutBlock).blocks) {
                    for (const row of column) {
                        if (this.briefingsService.isDynamicElementValid(row)) {
                            this.refreshDynamicBlockData(row);
                        }
                    };
                };
            } else {
                // we want to treat the full curator block as a normal block
                if (this.briefingsService.isDynamicElementValid(block)) {
                    this.refreshDynamicBlockData(block);
                }
            }
        };

        if (this.chartBlocks?.length) {
            this.briefingsService.refreshMultipleChartBlockData(this.chartBlocks);
            this.chartBlocks.forEach(chartBlock => {
                (chartBlock.displayElement as BriefingChartDisplayElementModel).chart.refreshed = true;
            });
        }

        // probably overkill, but we don't want to show the dialog if totalItems is 0.
        // (but they shouldn't be able to click the button either)
        if (this.progress.totalItems > 0) {
            this.coreDialogService.open(ProgressDialogComponent, {
                inputs: {
                    id: 'briefing_refresh_data',
                    headerLabel: 'Briefing.refreshData.dialog.heading',
                    generatingText: 'PageBuilder.blockType.curation.analysisGeneration.generating',
                    alertMessage: 'Briefing.refreshData.dialog.info',
                    alertType: messageSeverityEnum.info,
                    progress: this.progress,
                    showCount: false,
                    showCountBottom: true
                },
                outputs: {
                    dialogClose: (confirmed: boolean) => {
                        if (!confirmed) {
                            this.briefing.blocks = clonedBriefing.blocks;
                            this.briefingsService.setCurrentBriefing(this.briefing);
                        }
                    }
                }
            });
        }
    }

    private refreshDynamicBlockData(block: BlockModel): void {
        if (block.type.key === BriefingBlockTypeEnum.ANALYSIS) {
            this.progress.totalItems++;
            this.briefingCoverageAnalysisService.generateAiContentForBlocks([block], this.progress);
        }

        if (block.type.key === BriefingBlockTypeEnum.COVERAGE_CURATOR) {
            const curatorBlock = (block as CuratorBlock);

            // we have to reset the curator block before generating new content
            if (curatorBlock.displayElement.hasGeneratedContent) {
                curatorBlock.blocks = curatorBlock.originalBlocks;
                curatorBlock.displayElement.hasGeneratedContent = false;
                curatorBlock.originalBlocks = [];
                curatorBlock.blocks.forEach(b => {
                    if((b.type.key === BriefingBlockTypeEnum.AUTOMATIC_MENTION_LIST || b.type.key === BriefingBlockTypeEnum.ANALYSIS)
                        && b.displayElement.automaticallyGenerated
                    ) {
                        const dynamicMentionDisplayElement =
                            b.displayElement as DynamicMentionListDisplayElementModel | AnalysisDisplayElementModel;
                        dynamicMentionDisplayElement.backendDataSource = curatorBlock.displayElement.backendDataSource;
                        dynamicMentionDisplayElement.searchCriteriaId = curatorBlock.displayElement.searchCriteriaId;
                        dynamicMentionDisplayElement.sourceType = curatorBlock.displayElement.sourceType;
                    }
                });
            }

            let totalItems: number = 2;
            curatorBlock.blocks.forEach(child => {
                if (child.type.key === BriefingBlockTypeEnum.ANALYSIS) {
                    if ((child.displayElement as AnalysisDisplayElementModel)?.automaticallyGenerated) {
                        totalItems += 1;
                    }
                }
            });

            this.progress.totalItems += totalItems;
            this.briefingCoverageAnalysisService.refreshCuratorGeneration(curatorBlock, this.progress);
        }

        if (block.type.key === BriefingBlockTypeEnum.CHART) {
            this.progress.totalItems++;
            this.chartBlocks.push(block);
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach((sub) => sub.unsubscribe());
    }
}
